import React, {useEffect, useState} from "react";
import Carousel from "../../Carousel";
import {Alert, Avatar, Card, Tooltip} from "antd";
import shop from "../../../shopBigger.png";
import {ChartIcon, DollarIcon, IconButton, ShopIcon} from "evergreen-ui";
import {useCollection} from "react-firebase-hooks/firestore";
import Firebase from "../../../Firebase";
import {useHistory} from "react-router";
import {useGetImages} from "../../useGetImages";


const moment = require("moment");
const { Meta } = Card;
const db = Firebase.firestore();
const ViewOutlet = (props) => {

    const history = useHistory();
    const [userArray, setUserArray] = useState([]);
    const [users] = useCollection(
        db.collection('users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [outlet, setOutlet] = useState(props.outlet);
    const { images, imagesError } = useGetImages(`outlets/${props.outlet.outletID}`);
    
    useEffect(() => {
        if(users){
            var array = [];
            users.docs.map(user => {
                array.push(user.data());
            });
            setUserArray(array);
        }

        if(imagesError){
            console.log(imagesError);
        }
        
        if(images){
            console.log(images);
        }
        
        setOutlet(props.outlet);
        console.log(props.outlet);
    }, [images, props, users])
    
    return (
        <>

            <Card
                cover={
                    <Carousel urls={outlet&&outlet.urls}/>
                }
            >
                <Meta
                    avatar={<Avatar src={shop} />}
                    title={
                        <div className="d-flex flex-row justify-content-between">
                            <div>{outlet&&String(outlet.name).toUpperCase()}</div>
                            <div className="d-flex flex-row">
                                <Tooltip placement="bottom" title="Outlet Sales">
                                    <IconButton icon={DollarIcon} intent="success" className="mr-1" onClick={() => {
                                        history.push({
                                            pathname: '/sales',
                                            filter: outlet.name,
                                        });
                                    }}/>
                                </Tooltip>
                                <Tooltip placement="bottom" title="Outlet Logs">
                                    <IconButton icon={ChartIcon} intent={"danger"} className="mr-1" onClick={() => {
                                        history.push({
                                            pathname: '/logs',
                                            outlet: outlet.outletID,
                                        });
                                    }}/>
                                </Tooltip>

                                <Tooltip placement="bottom" title="Outlet Products">
                                    <IconButton icon={ShopIcon} intent="none" className="mr-2" onClick={() => {
                                        history.push({
                                            pathname: '/products',
                                            products: outlet.products,
                                            outlet: outlet
                                        });
                                    }}/>
                                </Tooltip>

                            </div>
                        </div>
                    }
                    description={<p className="font-italic">{outlet && outlet.feedbackNotes}</p>}
                />
                <div className="mt-3 d-flex flex-column">
                    <div className="d-flex flex-row justify-content-between my-1">
                        <Alert message={<><b>Location : </b>
                            {outlet&&`${outlet.district}, ${outlet.area}`}</>} className="w-100 mr-3" type="info" showIcon />
                        <Alert message={<><b>Date Created : </b>
                            {outlet&&moment(outlet.dateCreated, "YYYY-MM-DDTh:mm:ss").format("DD MMM YYYY")}</>}
                               className="w-100 mr-3" type="info" showIcon />
                    </div>
                    <div className="d-flex flex-row justify-content-between my-1">
                        <Alert message={<><b>Created By : </b>{
                            outlet&&
                            userArray[userArray.findIndex(x => (x.userID) === outlet.createdByID)]&&
                            userArray[userArray.findIndex(x => (x.userID) === outlet.createdByID)].firstname + " " +
                            userArray[userArray.findIndex(x => (x.userID) === outlet.createdByID)].surname
                        }</>
                        } className="w-100 mr-3" type="info" showIcon />
                        <Alert message={<><b>Coordinates: </b>{outlet&&outlet.coordinates.longitude + ", " + outlet.coordinates.latitude}</>}
                               className="w-100 mr-3" type="info" showIcon />
                    </div>
                    <div className="d-flex flex-row justify-content-between my-1">
                        <Alert
                            className="w-100 mr-3"
                            message={<b>Contact Details</b>}
                            description={
                                `${outlet&&outlet.contactPerson.name} - 
                                                        ${outlet&&outlet.contactPerson.email} -
                                                         ${outlet&&outlet.contactPerson.phone}`
                            }
                            type="info"
                            showIcon
                        />
                    </div>


                </div>

            </Card>
        
        </>
    )
}

export default ViewOutlet;
